import { ErrorResponse } from '../types';

export class AppError extends Error {
  error: string;
  status: number;
  path: string;
  timestamp: string;
  additionalDetails?: Record<string, any>;

  constructor(response: ErrorResponse) {
    super(response.message);
    this.name = 'AppError';
    this.error = response.error;
    this.status = response.status;
    this.path = response.path;
    this.timestamp = response.timestamp;
    this.additionalDetails = response.additionalDetails;
  }
}
